import '../config/polyfills';
import 'react-hot-loader';
import React from 'react';
import './fonts.css';
import { render } from 'react-dom';
import Main from './main';
import '@expert360/ui/lib/expert360-ui.css';
import { createRelayEnvironment, ErrorBoundary } from 'utils';
import getBootstrapDetails from 'core/getBootstrapDetails';
import { fetchUser } from 'core/context/UserContextHandler';
import * as Logger from 'utils/logger';

Logger.init({
  accessToken: process.env.ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.ROLLBAR_ENV,
    client: {
      javascript: {
        code_version: process.env.ROLLBAR_VERSION,
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
});

async function initApp() {
  const { csrfToken, flags, user: bootstrapUser } = await getBootstrapDetails();
  const relayEnvironment = createRelayEnvironment({ csrfToken });
  const contextUser = await fetchUser(relayEnvironment);

  const featureFlags = flags.reduce(
    (flags, flag) => ({ ...flags, [flag]: true }),
    {}
  );

  const config = {
    SEGMENT_API_KEY: process.env.SEGMENT_API_KEY,
    csrfToken,
  };

  render(
    <ErrorBoundary>
      <Main
        config={config}
        flags={featureFlags}
        relayEnvironment={relayEnvironment}
        bootstrapUser={bootstrapUser}
        contextUser={contextUser}
      />
    </ErrorBoundary>,
    document.getElementById('root')
  );
}

initApp();
